import React from 'react'

const withEventHandlers = WrappedComponent => {
  return props => {
    const {
      savePayment, // via withMutation
      createStripeToken // via withStripe
    } = props

    const handleClickContinue = event => {
      event.preventDefault()
      createStripeToken({ onSuccess: savePaymentWithConfirmationToken })
    }

    const savePaymentWithConfirmationToken = confirmationToken => {
      const { id, payment_method_preview: preview } = confirmationToken
      const isCard = preview?.type === 'card'

      const input = {
        paymentMethod: isCard ? 'card' : 'bank',
        confirmationToken: id
      }

      savePayment({ variables: { input } })
    }

    return <WrappedComponent onClickContinue={handleClickContinue} {...props} />
  }
}

export default withEventHandlers
